import './Donate.css';
import { Donate1Hero } from './components/Donate1Hero';
import { Donate1Impact } from './components/Donate1Impact';
import { Donate1ReportsCTA } from './components/Donate1ReportsCTA';
import { Helmet } from 'react-helmet-async';

export function Donate(): JSX.Element {

  return (
    <div className='Donate'>
      {/* @ts-ignore */}
      <Helmet>
        <title>Donate - Pangolino.org</title>
        <meta name="description" content="Support pangolin conservation."></meta>
        <link rel="canonical" href="/donate"></link>
      </Helmet>
      <Donate1Hero />
      <Donate1Impact />
      <Donate1ReportsCTA />
    </div>
  )
}
